import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { loadCSS } from 'fg-loadcss/src/loadCSS';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import jamaicaFlag from '../../../assests/images/jamaican-flag-graphic.png';
import barbadosFlag from '../../../assests/images/barbados-flag.gif';
import TurksAndCaicosFlag from '../../../assests/images/2000px-Flag_of_the_Turks_and_Caicos_Islands.svg_.png'

import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {fetchCompanyInfoByRegion, getRegionSelected} from '../../../store/actions/TopBar/TopBarAction';

const CompanyInfo = {
    regions:[
        {
            country: "Barbados",
            flag:barbadosFlag,
            alt: "BarbadosFlag"
        },
        {
            country: "Jamaica",
            flag: jamaicaFlag,
            alt: "Jamaica Flag"
        },
        {
            country: "Turks and Caicos",
            flag: TurksAndCaicosFlag,
            alt: "Turks and Caicos Flag"
        }
    ]        
}

const styles = theme => ({
    iconwrapper: {
        marginTop: theme.spacing.unit,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'baseline',
        fontSize: '12px'
    },
    flag: {
        width: '24px'
    },
    regionwrapper: {
        marginTop: theme.spacing.unit,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: "12px"
    },
    icon: {
        margin: theme.spacing.unit,
        fontSize: "12px"
    },
    icontext: {
        fontSize: "12px",
        fontWeight: "100",
        color: '#808080'
    },
    iconHover: {
        margin: theme.spacing.unit * 2,
        '&:hover': {
            color: '#333',
        },
    },
    responsiveIimg: {
        position: "relative",
        left: "20px",
        height: "auto !important",
    },
    topbar: {
        backgroundColor: '#f7f7f7',
        marginBottom: theme.spacing.unit,
        color: "#808080",
        fontSize: "12px",
        lineHeight: "100%"
    },
    GridList: {
        width: '100% !important',
        height: '30px',
        backgroundColor: '#f7f7f7',
        color: 'gray'
    },
    GridTile: {
        justifyContent: 'center',
        alignItems: 'center'
    }
});

class TopBar extends Component {

    componentDidMount() {
        loadCSS(
            'https://use.fontawesome.com/releases/v5.1.0/css/all.css',
            document.querySelector('#insertion-point-jss'),
        );
    }

    componentWillMount(){
        if(this.props.companyData.length <= 0)
            this.props.fetchCompanyInfoByRegion();

        if(!this.props.regionName)
            this.props.getRegionSelected();
    }

    render() {

        const { classes } = this.props;
        
        if(this.props.companyData.length <= 0)
            return null;

            if(!this.props.regionName)
                return null;

        const selectedCompanyData = this.props.companyData.find((element)=>{
            return element.region === this.props.regionName;
        });

        const companyFlag = CompanyInfo.regions.find((element)=>{
                return element.country === this.props.regionName;
            });

        return (
            <Grid
                container
                spacing={24}
                direction="row"
                justify="flex-start"
                alignContent="flex-start"
                className={classes.topbar}
            >
                <Grid
                    item
                    xs={2}
                >
                    <div className={classes.regionwrapper}>
                        <Typography className={classes.icontext}>
                            Region:
                </Typography>
                        <img className={classNames(classes.responsiveIimg, classes.flag)} src={companyFlag.flag } alt={companyFlag.alt} />
                    </div>
                </Grid>
                <Grid
                    item
                    xs={3}
                >  <div className={classes.regionwrapper}>
                        <Icon className={classNames(classes.icon, 'fas fa-envelope')} />
                        <Typography className={classes.icontext}>
                            {selectedCompanyData.email}
                </Typography>
                    </div>
                </Grid>
                <Grid
                    item
                    xs={3}
                >  <div className={classes.iconwrapper}>
                        <Icon className={classNames(classes.icon, 'fas fa-phone')} />
                        <Typography className={classes.icontext}>
                            {selectedCompanyData.tel}
                </Typography>
                    </div>
                </Grid>
            </Grid>
        );
    };
}

TopBar.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) =>
{
    return {
        companyData: state.topBar.companyData,
        regionName: state.topBar.regionName
    };
}

const matchDispatchToProps = (dispatch) =>
{
    return (
        bindActionCreators({
            fetchCompanyInfoByRegion: fetchCompanyInfoByRegion,
            getRegionSelected: getRegionSelected
        }, dispatch)
    );
        
    
};

export default connect(mapStateToProps, matchDispatchToProps)(withStyles(styles)(TopBar));
//export default withStyles(styles)(TopBar);



// WEBPACK FOOTER //
// ./src/components/Header/TopBar/TopBar.js